<script>
import highlightChunks from './highlightChunks';

const classAndStyleTypes = [Object, Array, String];

export default {
  name: 'text-highlight',
  props: {
    queries: [Array, String, RegExp],
    caseSensitive: Boolean,
    diacriticsSensitive: Boolean,
    highlightStyle: classAndStyleTypes,
    highlightClass: {
        type: classAndStyleTypes,
        default: 'u-text --highlight',
    },
    highlightComponent: {
      type: [String, Object],
      default: 'mark',
    },
  },
  data() {
    return {
      text: '',
    };
  },
  render() {
    return <span>
      {this.highlights
        .map(({
          text,
          isHighlighted,
          highlightIndex,
        }) => (
          !isHighlighted
            ? text
            : <this.highlightComponent
              class={this.highlightClass}
              style={this.highlightStyle}
              key={highlightIndex}
              index={highlightIndex}
              text={text}
              {...this.attributes}
            >
              {text}
            </this.highlightComponent>
        ))}
    </span>
  },
  // render: h => h ('span',
  //       { this.highlights
  //               .map(({
  //                         text,
  //                         isHighlighted,
  //                         highlightIndex,
  //                     }) => (
  //                   !isHighlighted
  //                       ? text
  //                       : <this.highlightComponent
  //           class={this.highlightClass}
  //           style={this.highlightStyle}
  //           key={highlightIndex}
  //           index={highlightIndex}
  //           text={text}
  //       {...this.attributes}
  //   >
  //       {text}
  //   </this.highlightComponent>
  //   ))}
  //   ),
  beforeMount() { this.setTextFromSlot(); },
  beforeUpdate() { this.setTextFromSlot(); },
  methods: {
    setTextFromSlot() {
      const defaultSlot = this.$slots.default;

      if (!defaultSlot) this.text = '';
      else if (defaultSlot[0].tag !== undefined && process.env.NODE_ENV !== 'production') {
        /* eslint-disable-next-line no-console */
        console.warn('children of <text-highlight> must be a plain string.');
        this.text = '';
      } else {
        this.text = defaultSlot[0].text;
      }
    },
  },
  computed: {
    attributes() {
      return {
        props: this.$attrs,
        on: this.$listeners,
      };
    },
    highlights() {
      const {
        text,
        queries,
        caseSensitive,
        diacriticsSensitive,
      } = this;
      return highlightChunks(text, queries, { caseSensitive, diacriticsSensitive });
    },
  },
};
</script>

<style lang="scss">
/*.u-text.--highlight {*/
/*  background: rgb(255, 204, 0);*/
/*  border-radius: 3px;*/
/*}*/
</style>
